import { Reducer } from "redux";

import { ReducerMap } from "@com.mgmtp.a12.client/client-core/lib/core/application";

import { accessibilityReducer, accessibilitySliceName } from "./accessibility/reducers";
import { AccessibilitySlice } from "./accessibility/types";
import { environmentReducer, environmentSliceName } from "./environmentData/reducers";
import { EnvironmentData } from "./environmentData/types";
import { fachverfahrenReducer, fachverfahrenSliceName } from "./fachverfahren/reducers";
import { FachverfahrenSlice } from "./fachverfahren/types";
import { stammdatenReducer, stammdatenSliceName } from "./stammdaten/reducers";
import { StammdatenSlice } from "./stammdaten/types";
import { validationReducer, validationSliceName } from "./validation/reducers";
import { ValidationSlice } from "./validation/types";
import { usersReducer, usersSliceName } from "./users/reducers";
import { UsersSlice } from "./users/types";
import { textbausteineReducer, textbausteineSliceName } from "./textbausteine/reducers";
import { TextbausteineSlice } from "./textbausteine/types";
import { operationsReducer, operationsSliceName } from "./operation/reducers";
import { OperationsSlice } from "./operation/types";

type NonNever<T> = keyof { [P in keyof T as T[P] extends undefined ? P : never]: T[P] };

type A12Slices = NonNever<ReducerMap>;
type A12State = { [P in A12Slices]: unknown };

export interface ModulFState extends A12State {
	readonly [fachverfahrenSliceName]: FachverfahrenSlice;
	readonly [stammdatenSliceName]: StammdatenSlice;
	readonly [validationSliceName]: ValidationSlice;
	readonly [accessibilitySliceName]: AccessibilitySlice;
	readonly [environmentSliceName]: EnvironmentData;
	readonly [usersSliceName]: UsersSlice;
	readonly [textbausteineSliceName]: TextbausteineSlice;
	readonly [operationsSliceName]: OperationsSlice;
}

export type ModuleFReducers = {
	[P in Exclude<keyof ModulFState, A12Slices>]: Reducer<ModulFState[P]>;
};

export const modulFReducers: ModuleFReducers = {
	[fachverfahrenSliceName]: fachverfahrenReducer,
	[stammdatenSliceName]: stammdatenReducer,
	[validationSliceName]: validationReducer,
	[accessibilitySliceName]: accessibilityReducer,
	[environmentSliceName]: environmentReducer,
	[usersSliceName]: usersReducer,
	[textbausteineSliceName]: textbausteineReducer,
	[operationsSliceName]: operationsReducer
};
